import { SubscriberAddressModel } from "./SubscriberAddressModel"
import { SubscriberProductModel } from "./SubscriberProductModel"

export class SubscriberModel {
    id: string = ""
    name: string = ""
    realName: string = ""
    publicKey: string = ""
    document: string = ""
    timezone: string = ""
    alias: string = ""
    idExternal: string = ""
    isCustomer: boolean = false
    loadingListAction?: boolean = false
    products: SubscriberProductModel[] = []
    addresses: SubscriberAddressModel[] = []

    constructor(s?:Partial<SubscriberModel>) {
        Object.assign(this, s)

        this._parseAddresses()
        this._parseProducts()
    }

    getAddress():SubscriberAddressModel {
        return this.addresses[0] ?? new SubscriberAddressModel()
    }

    private _parseAddresses():void {
        this.addresses = (this.addresses || []).map((ad) => new SubscriberAddressModel(ad))
    }

    private _parseProducts():void {
        this.products = (this.products || []).map((p) => new SubscriberProductModel(p))
    }
}
